export default __webpack_public_path__ + "e271e06.png";